import { Phone } from "@phosphor-icons/react";

export const CrisisBanner = () => (
  <div className="w-full bg-[#2C362B] text-[#F4F1E8]" data-testid="crisis-banner">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-center gap-2 text-center text-xs sm:text-sm">
      <Phone size={16} weight="fill" className="shrink-0 text-[#F8CDB0]" />
      <span>
        In crisis or thinking about suicide? Call or text{" "}
        <a href="tel:988" className="font-bold underline underline-offset-2 hover:text-white" data-testid="crisis-988-link">988</a>
        {" "}— the Suicide &amp; Crisis Lifeline, free &amp; 24/7.
      </span>
    </div>
  </div>
);
